import TiptapDocument from '@tiptap/extension-document';

export const Document = TiptapDocument.extend({
  content: '(block|topLevelBlock?)+',
});
